import { render, staticRenderFns } from "./index.vue?vue&type=template&id=44213c91&scoped=true"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=44213c91&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44213c91",
  null
  
)

export default component.exports